import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { DhlFormControl } from '../../models/dhl-form-control';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import moment from 'moment';

@Component({
    selector: 'app-form-field-daterangepicker-v2',
    templateUrl: './form-field-daterangepicker-v2.component.html',
    styleUrls: ['./form-field-daterangepicker-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDaterangepickerV2Component implements OnInit,AfterViewInit {

  selected: any;
  maxDate: any = moment(); // This will disable all future dates
  combinedDates
  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last week': [moment().subtract(6, 'days'), moment()],
    'Last 30 days': [moment().subtract(29, 'days'), moment()],
    'Last 90 days': [moment().subtract(90, 'days'), moment()]
  }
  locale: any = {
    customRangeLabel: 'Custom Range',
    format: ''
  }
  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;
  dateRangePayload: any;
  apiCall;

  constructor(private appService: AppService,  private alphaService : AlphaService) { }

  ngOnInit() {
    this.apiCall = 0;
    if(this.configData?.displayFormat){
      this.locale.format=this.configData?.displayFormat
    }
  }
 
  ngAfterViewInit() {
    if (this.configData.hasOwnProperty("storeDataName")) {
      if (sessionStorage.getItem(this.configData['storeDataName']) && JSON.parse(sessionStorage.getItem(this.configData['storeDataName']))) {
        if (sessionStorage.getItem(this.configData['storeDataName']+ "-Payload")) {
          this.dateRangePayload = JSON.parse(sessionStorage.getItem(this.configData['storeDataName'] + "-Payload"));
        }
        let dates = JSON.parse(sessionStorage.getItem(this.configData['storeDataName'])).split(",");
        this.selected = this.selected ? this.selected : {};
        this.selected.startDate = moment(dates[0]);
        this.selected.endDate = moment(dates[1]);
        this.sendToSource(JSON.parse(sessionStorage.getItem(this.configData['storeDataName'])), null);
      }
      else{
        this.apiCall++;
      }
    }
     let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name]) {
      sessionStorage.setItem(this.configData['storeDataName'], filterObj[this.configData.name] ? JSON.stringify(filterObj[this.configData.name]) : filterObj[this.configData.name])
    }
  }

  onSelectedChange(userEvent) {
    this.apiCall++;
    // console.log("api call ", this.apiCall)
    if (!userEvent.startDate && !userEvent.endDate) {
      if (this.apiCall > 2) {
        sessionStorage.removeItem(this.configData['storeDataName']);
        sessionStorage.removeItem(this.configData['storeDataName'] + "-Payload");
        this.sendToSource(null, userEvent);
      }
    }
    else if (userEvent.startDate && userEvent.endDate) {
      if (this.apiCall > 2) {
        this.combinedDates = userEvent.startDate.format('YYYY-MM-DD') + ',' + userEvent.endDate.format('YYYY-MM-DD');
        this.sendToSource(this.combinedDates, userEvent);
      }
    }
  }
 
  sendToSource(formattedDate, userEvent) {
    let queryString = '';
    let events = this.configData.events;
    if (events && events.length > 0) {
      let eventData: DhlFormControlEventData = {
        event: events[0].event,
        eventData: events[0],
        action: events[0].action,
        name: this.configData.name,
        component: this,
        configData: this.configData,
        data: { value: formattedDate, queryString: queryString }
      }
      
      if(this.selected && this.selected.startDate && this.selected.endDate){
        this.dateRangePayload = this.dateRangePayload ? this.dateRangePayload : {};
        this.dateRangePayload[this.configData.name] =[{
          "operator": this.configData['operator'],
          "value": [this.selected.startDate.format('YYYY-MM-DD'), this.selected.endDate.format('YYYY-MM-DD')]
        }];
      }
      
      if (formattedDate && this.configData['storeDataName']) {
        sessionStorage.setItem(this.configData['storeDataName'] + '-Payload', JSON.stringify(this.dateRangePayload));
        sessionStorage.setItem(this.configData['storeDataName'], formattedDate ? JSON.stringify(formattedDate) : formattedDate)
      }
      eventData['userEvent'] = userEvent;
      eventData['dateRangePayload'] = this.dateRangePayload;

      let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
      if (filterObj) {
        filterObj[this.configData.name] = JSON.parse(sessionStorage.getItem(this.configData['storeDataName']));
        this.alphaService.setFilteredObject("setFiltersValues", filterObj);
      }
      this.appService._commonComponentSubject.next(eventData);
    }
  }
}





